import Icon from '@eversports/klimt-primitives/legacy/Icon'
import Link from '@eversports/klimt-primitives/legacy/Link'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import LocationIcon from '../../../../assets/icons/location.svg'
import { Localized } from '../../../../localization/react'
import { VENUE_PROFILE_MAP_ID } from '../../VenueProfile.constants'

interface Props {
  address?: string
}

const Address = ({ address }: Props) => {
  return (
    <Link to={`#${VENUE_PROFILE_MAP_ID}`} external>
      <Stack direction="row" alignItems="center" gap={1} sx={{ cursor: address ? 'pointer' : 'default' }}>
        <Icon src={LocationIcon} size="small" color="darkgray" />
        <Text
          variant="small"
          sx={{
            fontWeight: 'bold',
            color: 'text.primary',
            textDecoration: address ? 'underline' : 'default',
          }}
        >
          {address ?? <Localized id="listing-result-online-only-venue" />}
        </Text>
      </Stack>
    </Link>
  )
}

export default Address
